/** Routine schedule math — which weekdays a routine lands on. Pure (no imports)
 *  so the editor's days[] contract is unit-testable. */

export const WEEKDAY_COUNT = 7;

/** JS getDay convention: Sunday = 0 … Saturday = 6. */
export function routinesForDate<T extends { days: unknown }>(routines: T[], date: Date): T[] {
  const weekday = date.getDay();
  return routines.filter((routine) => Array.isArray(routine.days) && routine.days.includes(weekday));
}
